/* eslint-disable react/jsx-key */
/** import package [start] */
import { useTable, useResizeColumns } from "react-table";
import { Spinner, Card, Row } from "react-bootstrap";
import { CgUnavailable } from "react-icons/cg";
import React, { useMemo, useState } from "react";
import { MdDangerous, MdWarning } from "react-icons/md";
import Transition from "./Transition";
import Modal from "./Modal";
const getAlertVariant = (key) => {
    let variant = "";
    switch (key === null || key === void 0 ? void 0 : key.toLowerCase()) {
        case "critical":
            variant = "danger";
            break;
        case "warning":
            variant = "warning";
            break;
        default:
            variant = "primary";
            break;
    }
    return variant;
};
/**
 * data table component
 * @param param0 DataTableProps
 * @returns
 */
const DataTable = ({ columns, data, total, isLoading, columnNames, noDataElement = (React.createElement("span", { style: { "fontSize": "xx-large" } },
    React.createElement(CgUnavailable, { size: 40, className: "fs-4 text-primary" }),
    " There are currently no alerts to show.")), }) => {
    var _a, _b;
    const defaultColumn = useMemo(() => ({
        width: 70,
        minWidth: 50,
        maxWidth: 100
    }), []);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data, defaultColumn }, useResizeColumns);
    const [show, setShow] = useState(false);
    const [alertBody, setAlertBody] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { body: true, className: "alerts_table" },
            React.createElement("table", Object.assign({}, getTableProps(), { className: "table table-hover table-borderless table-custom text-center" }),
                React.createElement("thead", null, headerGroups.map((headerGroup) => (React.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps(), { className: "border-bottom" }), headerGroup.headers.map((column) => (React.createElement("th", Object.assign({}, column.getHeaderProps(), { scope: "col" }), column.render("Header")))))))),
                !isLoading && (React.createElement(React.Fragment, null,
                    React.createElement("tbody", Object.assign({}, getTableBodyProps()), rows.map((row, index) => {
                        prepareRow(row);
                        return (React.createElement("tr", Object.assign({}, row.getRowProps(), { className: `${rows.length - 1 !== index && "border-bottom"} cursor-pointer`, onClick: () => {
                                setAlertBody(row.original);
                                handleShow();
                            } }), row.cells.map((cell) => {
                            return (React.createElement("td", Object.assign({}, cell.getCellProps()), cell.render("Cell")));
                        })));
                    })),
                    React.createElement(Modal, { show: show, onHide: handleClose, modalClassName: "alert-description-modal", size: "lg" },
                        React.createElement("div", { className: "mt-3 ms-2" },
                            getAlertVariant(alertBody.severity) === "danger" && React.createElement(React.Fragment, null,
                                React.createElement(MdDangerous, { size: 50, style: { "color": "#eb6b77" } }),
                                " ",
                                " ",
                                " ",
                                React.createElement("h4", { className: "d-inline" }, "Critical")),
                            getAlertVariant(alertBody.severity) === "warning" && React.createElement(React.Fragment, null,
                                React.createElement(MdWarning, { className: "ms-2", size: 50, style: { "color": "#FFC50C" } }),
                                " ",
                                " ",
                                " ",
                                React.createElement("h4", { className: "d-inline" }, "Warning"))),
                        React.createElement("div", { className: "alert-modal-body" },
                            React.createElement("span", { className: "d-flex justify-content-center gap-2 network-node-id" },
                                (alertBody === null || alertBody === void 0 ? void 0 : alertBody.networkId) && ((_a = alertBody.networkId) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== "NA" &&
                                    React.createElement(Card, { body: true, className: "text-center mb-2 pe-1" },
                                        React.createElement("span", { className: "d-block" },
                                            React.createElement("b", null,
                                                (columnNames && columnNames.networkId) || "Network ID",
                                                ":")),
                                        React.createElement("span", { className: "text-truncate", title: alertBody.networkId }, alertBody.networkId)),
                                (alertBody === null || alertBody === void 0 ? void 0 : alertBody.nodeId) && ((_b = alertBody.nodeId) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== "NA" &&
                                    React.createElement(Card, { body: true, className: "text-center mb-2 pe-1" },
                                        React.createElement("span", { className: "d-block" },
                                            React.createElement("b", null,
                                                (columnNames && columnNames.nodeId) || "Node ID",
                                                ":")),
                                        React.createElement("span", { className: "text-truncate", title: alertBody.nodeId }, alertBody.nodeId))),
                            React.createElement("span", { className: "alerts-details-section" },
                                React.createElement(Card, { body: true, className: "alerts-details-card overflow-y-only p-3" },
                                    React.createElement(Row, null, Object.entries(alertBody)
                                        .filter(([key, value]) => (key && value && key !== "networkId" && key !== "nodeId"))
                                        .map(([key, value], index) => {
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement("div", { key: index, className: "col-lg-4 col-sm-12 my-1" }, (columnNames && columnNames[key]) || key),
                                            React.createElement("div", { className: "col-lg-8 col-sm-12 my-1" }, (typeof value === "number" || value.length < 37) ?
                                                React.createElement("span", { className: "float-right" }, value) :
                                                React.createElement(Transition, { heading: React.createElement("span", { className: "float-right cursor-pointer text-truncate transition-heading" }, value), body: value }))));
                                    }))))))))),
            isLoading && (React.createElement("div", { className: "text-center position-absolute top-50 start-50" },
                React.createElement(Spinner, { animation: "border", className: "mt-5 text-primary" }))),
            !isLoading && total === 0 && (React.createElement("div", { className: "text-center text-muted fw-bold mt-5 d-flex justify-content-center align-items-center", style: { "height": "60%" } }, noDataElement)))));
};
export default DataTable;
